import moment from "moment/moment";

export const TimeFormat = (time = new Date(), format = "DD MMM YYYY") => {
    return moment(time).format(format);
};